import React from 'react';
import { WrapperMessage } from './InscriptionsStyled';
import NoEvents from '../../../../../../assets/icons/events/noevents.svg';
import {
  ContainerDefaultMessage,
  DefaultText
} from '../../../../common/CardBoardStyled';

const DefaultMessage = () => (
  <ContainerDefaultMessage>
    <WrapperMessage>
      <img src={NoEvents} alt="Sin eventos" />
      <DefaultText>¡Empieza a inscribirte en tu primer Evento!</DefaultText>
    </WrapperMessage>
  </ContainerDefaultMessage>
);

export default DefaultMessage;
